import type {
  PartnerMetadataState,
  PartnerMetadataTrustLevel,
} from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/partnerMetadata/partnerMetadata';

export { partnerMetadataReducer, INITIAL_STATE } from './partnerMetadataReducer';
export type {
  PartnerMetadata,
  PartnerMetadataState,
  PartnerMetadataTrustLevel,
} from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/partnerMetadata/partnerMetadata';

export const get = (state: PartnerMetadataState, id: string): PartnerMetadataTrustLevel =>
  state.byId[id];
export const getAll = (state: PartnerMetadataState): Record<string, PartnerMetadataTrustLevel> =>
  state.byId;
